/**
 * Created by igor.kulishov on 9/1/2016.
 */
(function () {

    'use strict';

    angular
        .module('app.vehicledetails')
        .directive('imagesOnLoad', ['$timeout', function ($timeout) {
            var countImags = 0;
            return {
              link: function(scope, elem) {

                  elem.bind('load', function(e){
                      ++countImags;
                      if (countImags == scope.printPreviewImgs.length) {
                          $timeout(function(){
                              angular.element(document).find('#equipment_component img').remove();
                              angular.element(document).find('.high-values').css('font-weight', 'bold');
                              window.print();
                          }, 0);
                      }
                  });

              }
            };
        }]);
})();


// WEBPACK FOOTER //
// ./app/vehicledetails/directives/ImagesOnLoad.js